<template>
    <div class="summary-table-page">
        <SummaryTableQuerySidePanel v-if="isReady" />
        <div class="data-block">
            <ButtonSet @onMarkDeclared="onOpenUpdateStatusDialog" />
            <div class="summary-bar">
                <div class="item">
                    <div class="label">{{ `[${typeLabelText}]` }} 單據張數</div>
                    <div class="value">
                        <money :v="totalDataCount" />
                    </div>
                </div>
                <div class="item">
                    <div class="label">{{ `[${typeLabelText}]` }} 未稅金額總計</div>
                    <div class="value">
                        <money :v="nonTaxSum" />
                    </div>
                </div>
                <div class="item">
                    <div class="label">{{ `[${typeLabelText}]` }} 稅額總計</div>
                    <div class="value">
                        <money :v="taxSum" />
                    </div>
                </div>
                <div class="item">
                    <div class="label">{{ `[${typeLabelText}]` }} 含稅金額總計</div>
                    <div class="value">
                        <money :v="nonTaxSum + taxSum" />
                    </div>
                </div>
                <template v-if="queryType === 1">
                    <div class="item">
                        <div class="label">{{ `[${typeLabelText}]` }} 折讓未稅金額總計</div>
                        <div class="value">
                            <money :v="dataStatistic.invoiceDiscountUntaxAmtSum" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">{{ `[${typeLabelText}]` }} 折讓稅額總計</div>
                        <div class="value">
                            <money :v="dataStatistic.invoiceDiscountTaxSum" />
                        </div>
                    </div>
                </template>
            </div>
            <DataTable ref="DataTable" :showPeriod="true" @onOpenInvoiceDetail="onOpenInvoiceDetail" @onOpenPaymentDetail="onOpenPaymentDetail" @onOpenTranInvoiceDetail="onOpenTranInvoiceDetail" />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import SummaryTableQuerySidePanel from '@/components/dashboard/Accounting/BusinessTax/SummaryTableQuerySidePanel.vue';
import ButtonSet from '@/components/dashboard/Accounting/BusinessTax/ButtonSet.vue';
import DataTable from '@/components/dashboard/Accounting/BusinessTax/DataTable.vue';

export default {
    components: { ButtonSet, DataTable, SummaryTableQuerySidePanel },
    created() {
        this.updateData();
    },
    computed: {
        ...mapState({
            isReady: (state) => state.businessTax.isReady,

            declarePeriod: (state) => state.businessTax.declarePeriod,
            periodList: (state) => state.businessTax.periodList,
            queryType: (state) => state.businessTax.queryParams.QueryType,

            totalDataCount: (state) => state.businessTax.totalDataCount,
            dataStatistic: (state) => state.businessTax.dataStatistic,
        }),
        period: {
            get() {
                return this.declarePeriod;
            },
            set(val) {
                this.setDeclarePeriod(val);
            },
        },
        typeLabelText() {
            return this.queryType === 1 ? '銷項' : '進項';
        },
        nonTaxSum() {
            switch (this.queryType) {
            case 2:
                return this.dataStatistic.paymentUntaxAmtSum;
            case 3:
                return this.dataStatistic.paymentInvoiceUntaxAmtSum;
            default:
                return this.dataStatistic.invoiceUntaxAmtSum;
            }
        },
        taxSum() {
            switch (this.queryType) {
            case 2:
                return this.dataStatistic.paymentTaxSum;
            case 3:
                return this.dataStatistic.paymentInvoiceTaxSum;
            default:
                return this.dataStatistic.invoiceTaxSum;
            }
        },
    },
    methods: {
        ...mapMutations({
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
        }),

        onOpenPaymentDetail(sno) {
            this.$emit('openPayment', sno);
        },
        onOpenInvoiceDetail(sno) {
            this.$emit('openInvoice', sno);
        },
        onOpenTranInvoiceDetail(tioo) {
            this.$emit('openTranInvoice', tioo);
        },
        onOpenUpdateStatusDialog(datas) {
            this.$emit('openUpdateStatusDialog', datas);
        },
    },
};
</script>
<style lang="scss" scoped>
.summary-table-page {
    display: flex;
    // align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;

    .container {
        height: fit-content;
        display: flex;
        margin-top: -25px;
        .data-block {
            background-color: #fff;
            border-radius: 15px;
        }
    }

    .summary-bar {
        display: flex;
        gap: 32px;
        padding: 5px 12px 10px 20px;
        border-bottom: 1px solid #eee;

        .item {
            .label {
                color: #51565e;
                font-size: 10pt;
            }
        }
    }
}
</style>
